import { postMergeCart } from '@/api/postMergeCart';
import type { LocalCartItem } from '@/types';
import { pickErrorMessages } from '@/utils/functions';

const CART_MERGED_KEY = 'cartMerged';

let _isMerging = false;
export const isCartMerging = () => _isMerging;

/**
 * ローカルカートをサーバーにマージし、既存アイテムが追加された場合は通知フラグを立てる
 * @returns カートマージで件数が増えた場合 true
 */
export const mergeCartWithNotification = async (
  items: LocalCartItem[],
  clearCartInfo: () => void,
): Promise<boolean> => {
  _isMerging = true;
  try {
    const localItemCount = items.length;
    const data = items.map((item) => ({
      userPrintId: item.userPrintId,
      quantity: item.quantity,
      timestamp: item.timestamp,
    }));

    const mergeResult = await postMergeCart({ items: data });
    clearCartInfo();

    // マージ後のサーバーカート件数を取得し、ローカルより増えていたら通知フラグを立てる
    // ログイン先のアカウントでカートにグッズがあった場合に
    // マージが発生して意図しない個数の商品を買うトラブルを防止する
    if (mergeResult.result.cart.totalItems > localItemCount) {
      try {
        sessionStorage.setItem(CART_MERGED_KEY, 'true');
      } catch (error) {
        pickErrorMessages(error);
      }
      return true;
    }
    return false;
  } finally {
    _isMerging = false;
  }
};

/**
 * カートマージ通知フラグを消費して返す
 */
export const consumeCartMergedFlag = (): boolean => {
  try {
    if (sessionStorage.getItem(CART_MERGED_KEY)) {
      sessionStorage.removeItem(CART_MERGED_KEY);
      return true;
    }
  } catch (error) {
    pickErrorMessages(error);
  }
  return false;
};
